var t;!function(t){t.Interactive="INTERACTIVE",t.NonInteractive="NON_INTERACTIVE"}(t||(t={}));export{t as GameplayMode};
